import { PageableResponse, RestClient } from "..";

export type B050020FindRequest = Partial<{
  shireYmdFrom: string;
  shireYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  hachudenpyoNoFrom: string;
  hachudenpyoNoTo: string;
  shireCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B050020FindResponse = {
  shiredenpyoNo: string;
  shireYmdF: string;
  hachudenpyoNoF: string;
  shireNm: string;
  shainNm: string;
  bumonNm: string;
  shireKin: string;
};

// 検索メソッド
export const B050020Find = (props: B050020FindRequest) => {
  return RestClient.get<PageableResponse<B050020FindResponse[]>>(
    "b050020/find",
    {
      params: props,
    }
  );
};

export type B050020GetRequest = Partial<{
  shiredenpyoNo: string;
}>;

export type B050020GetResponse = {
  shiredenpyoNo: string;
  hachudenpyoNo: string;
  juchudenpyoNo: string;
  shiredenpyoNoF: string;
  shireYmd: string;
  shireCd: string;
  shireNm: string;
  shireshokuchiKbn: number;
  eigyoCd: string;
  bumonCd: string;
  bumonNm: string;
  shainCd: string;
  shainNm: string;
  chohaKbn: string;
  bikoCd: string;
  biko: string;
  getsujiYmd: string;
  keijoYm: string;
  version: string;
  shireKinGokei: string;
  zeiKinGokei: string;
  gokei: string;
  shohizeiritsu: string;
  shiregyoNo: number;
  hachugyoNo: string;
  juchugyoNo: string;
  nyukoYmd: string;
  uchiwakeKbn: string;
  uchiwakeNm: string;
  shohinCd: string;
  shohinshokuchiKbn: number;
  shohinNm: string;
  sokoCd: string;
  sokoNm: string;
  sokoshubetsuKbn: string;
  locationkanriKbn: string;
  zoneCd: string;
  locationCd: string;
  locationCdF: string;
  shiresu: string;
  tenyuryokuKbn: string;
  shiretanka: string;
  basetanka: string;
  shireKin: string;
  kasanfugo: number;
  meisaibikoCd: string;
  meisaibiko: string;
  hachusu: string;
  keijozumisu: string;
  kazeiKbn: string;
  kanryoKbn: string;
};

// 仕入データ取得メソッド
export const B050020Get = (props: B050020GetRequest) => {
  return RestClient.get<B050020GetResponse[]>("b050020/get", {
    params: props,
  });
};

// 削除メソッド
export type B050020DeleteRequest = Partial<{
  shiredenpyoNo: string;
}>;

// 仕入入力削除メソッド
export const B050020Delete = (props: B050020DeleteRequest) => {
  return RestClient.delete("b050010/delete", { data: props });
};
